import React, { useState, useRef, useEffect } from 'react'
import CurrencyInput from '../../CurrencyInput'
import { sanitizeHTML } from '../../../../shared/utils/common-utils'

const tableDefaults = [
  [
    { text: 'FRA', bgColor: 'DarkMint', textColor: 'White' },
    { text: '62', bgColor: 'Mint', textColor: 'White' },
    { text: '63', bgColor: 'Mint', textColor: 'White' },
    { text: '64', bgColor: 'Mint', textColor: 'White' },
    { text: '65', bgColor: 'Mint', textColor: 'White' },
    { text: '66', bgColor: 'Mint', textColor: 'White' },
    { text: '67', bgColor: 'Mint', textColor: 'White' },
    { text: '68', bgColor: 'Mint', textColor: 'White' },
    { text: '69', bgColor: 'Mint', textColor: 'White' },
    { text: '70', bgColor: 'Mint', textColor: 'White' },
  ],
  [
    { text: '66', bgColor: 'DarkMint', textColor: 'White' },
    { text: '75%', bgColor: 'White', textColor: 'Brand' },
    { text: '80%', bgColor: 'White', textColor: 'Brand' },
    { text: '86.7%', bgColor: 'White', textColor: 'Brand' },
    { text: '93.3%', bgColor: 'White', textColor: 'Brand' },
    { text: '100%', bgColor: 'White', textColor: 'Brand' },
    { text: '108%', bgColor: 'White', textColor: 'Brand' },
    { text: '116%', bgColor: 'White', textColor: 'Brand' },
    { text: '124%', bgColor: 'White', textColor: 'Brand' },
    { text: '132%', bgColor: 'White', textColor: 'Brand' },
  ],
  [
    { text: '67', bgColor: 'DarkMint', textColor: 'White' },
    { text: '70%', bgColor: 'White', textColor: 'Brand' },
    { text: '75%', bgColor: 'White', textColor: 'Brand' },
    { text: '80%', bgColor: 'White', textColor: 'Brand' },
    { text: '86.7%', bgColor: 'White', textColor: 'Brand' },
    { text: '93.3%', bgColor: 'White', textColor: 'Brand' },
    { text: '100%', bgColor: 'White', textColor: 'Brand' },
    { text: '108%', bgColor: 'White', textColor: 'Brand' },
    { text: '116%', bgColor: 'White', textColor: 'Brand' },
    { text: '124%', bgColor: 'White', textColor: 'Brand' },
  ],
]

const getEstimateValue = (strPercent, strEstimate) => {
  const percent = parseFloat(strPercent)
  const estimate = parseFloat(strEstimate)
  const result = (percent * estimate) / 100
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
  }).format(result)
}
const SocialSecurityTable = props => {
  const renderTableCell = (text, bgColor, textColor, key, estimate, classNames = '') => {
    const finalClassName = `u-textSizeMsrp1 u-border u-borderColorTertiary u-borderWidthMedium u-paddingVert7gu u-textColor${textColor} ${
      bgColor ? `u-bgColor${bgColor}` : ''
    } ${classNames}`
    const ptClassNames = `${textColor ? `u-textColor${textColor}` : ''}`
    return (
      <td key={key} className={finalClassName}>
        <div className='u-flex u-flexCol'>
          <div className={ptClassNames}>{text}</div>
          {estimate && <div className='u-marginTop2gu'>{getEstimateValue(text, estimate)}</div>}
        </div>
      </td>
    )
  }
  const renderTableRow = (row, index, estimated) => {
    const isHeaderRow = index === 0
    const isBodyRow = !isHeaderRow
    const highlightRow = isBodyRow && index === props.highlightedRow
    const rowClassNames = 'u-textSizeMsrp1 u-textPrimary u-textBold u-textCenter'
    return (
      <tr key={`row-${index}`} className={rowClassNames}>
        {row.map((cell, cellIndex) => {
          const isFirstColumn = cellIndex === 0
          let textColor
          let bgColor
          let estimate
          let className = ''
          if (props.resultsVisible && !isFirstColumn) {
            estimate = estimated
          }
          if (!props.resultsVisible) {
            bgColor = cell.bgColor
            textColor = cell.textColor
            if (cell.text === '100%') {
              bgColor = 'Brand'
              textColor = 'White'
            }
          } else {
            if (highlightRow && isFirstColumn) {
              textColor = 'White'
              bgColor = 'DarkMint'
            } else if (highlightRow && cellIndex === props.highlightedColumn) {
              textColor = 'White'
              bgColor = 'Orange'
            } else if (highlightRow) {
              textColor = 'Brand'
              className = 'subHighlightMain'
            } else if (isBodyRow && !isFirstColumn) {
              className = 'subHighlightGrey'
              textColor = cell.textColor
            } else {
              bgColor = cell.bgColor
              textColor = cell.textColor
            }
          }
          return renderTableCell(
            cell.text,
            bgColor,
            textColor,
            `row-${index}-column-${cellIndex}`,
            estimate,
            className
          )
        })}
      </tr>
    )
  }
  return (
    <div className='social-security-layout u-pt-paddingHoriz0 u-sizeFull u-flex u-flexCol u-bgColorWhite u-paddingHoriz10gu'>
      <div className='u-textSizeMsrp1 u-textBold u-textCenter u-paddingVert2gu '>
        Estimated Monthly Social Security Payout
      </div>
      <div className='social-security-content u-sizeFull u-flex u-bgColorWhite u-paddingBottom8gu'>
        <table className='u-sizeFull'>
          <thead>
            <tr>
              <th
                colSpan='11'
                className='u-textSizeMsrp1 u-textCenter u-textBold u-textColorWhite u-bgColorBrand u-paddingVert6gu u-textSecondary'>
                Social Security Claiming Age
              </th>
            </tr>
            {renderTableRow(props.tableData[0], 0)}
          </thead>
          <tbody>
            {props.tableData
              .slice(1)
              .map((row, index) => renderTableRow(row, index + 1, props.estimate))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

const SocialSecurity = props => {
  const initialState = {
    FRAValue: '0',
    ageOfCollectionValue: '0',
    resultsVisible: false,
    monthlySocialSecurityBenefitEstimate: '',
  }
  const [state, setState] = useState(() => {
    const savedState = localStorage.getItem(`SocialSecurity`)
    return savedState ? JSON.parse(savedState) : initialState
  })
  const [FRAError, setFRAError] = useState(false)
  const [ageOfCollectionError, setAgeOfCollectionError] = useState(false)
  const [fraOptions] = useState([
    { value: '0', label: '-' },
    { value: '1', label: '66' },
    { value: '2', label: '67' },
  ])
  const [ageOptions] = useState([
    { value: '0', label: '-' },
    { value: '1', label: '62' },
    { value: '2', label: '63' },
    { value: '3', label: '64' },
    { value: '4', label: '65' },
    { value: '5', label: '66' },
    { value: '6', label: '67' },
    { value: '7', label: '68' },
    { value: '8', label: '69' },
    { value: '9', label: '70' },
  ])

  const FRARef = useRef(0)
  const ageOfCollectionRef = useRef(0)

  useEffect(() => {
    FRARef.current.value = state.FRAValue
    ageOfCollectionRef.current.value = state.ageOfCollectionValue
    localStorage.setItem(`SocialSecurity`, JSON.stringify(state))
  }, [state])

  const handleStateChange = (name, value) => {
    setState(prev => ({ ...prev, [name]: value }))
  }

  const returnFRA = value => {
    let age = ''
    switch (Number(value)) {
      case 0:
        age = 'No value selected'
        break
      case 1:
        age = '66'
        break
      case 2:
        age = '67'
        break
      default:
        age = ''
    }
    return age
  }

  const returnRetirementAge = value => {
    let age = ''
    switch (Number(value)) {
      case 0:
        age = 'No value selected'
        break
      case 1:
        age = '62'
        break
      case 2:
        age = '63'
        break
      case 3:
        age = '64'
        break
      case 4:
        age = '65'
        break
      case 5:
        age = '66'
        break
      case 6:
        age = '67'
        break
      case 7:
        age = '68'
        break
      case 8:
        age = '69'
        break
      case 9:
        age = '70'
        break
      default:
        age = ''
    }
    return age
  }

  const FRAValueToRow = value => {
    if (value === '1') {
      return 1
    } else if (value === '2') {
      return 2
    } else if (value === '3') {
      return 3
    } else {
      return null
    }
  }

  const ageOfCollectionValueToColumn = value => {
    let integer = parseInt(value)
    return integer
  }

  const handleSeeResults = () => {
    if (state.FRAValue !== '0' && state.ageOfCollectionValue !== '0') {
      setFRAError(false)
      setAgeOfCollectionError(false)
      handleStateChange('resultsVisible', true)
    } else {
      if (state.FRAValue === '0') {
        setFRAError(true)
      }
      if (state.ageOfCollectionValue === '0') {
        setAgeOfCollectionError(true)
      }
    }
  }

  const handleChangeFRA = () => {
    handleStateChange('FRAValue', FRARef.current.value)
  }

  const handleChangeAOC = () => {
    handleStateChange('ageOfCollectionValue', ageOfCollectionRef.current.value)
  }

  const handleReset = () => {
    handleStateChange('resultsVisible', false)
    FRARef.current.value = '0'
    ageOfCollectionRef.current.value = '0'
    handleStateChange('FRAValue', '0')
    handleStateChange('ageOfCollectionValue', '0')
    handleStateChange('monthlySocialSecurityBenefitEstimate', '')
    setFRAError(false)
    setAgeOfCollectionError(false)
    localStorage.removeItem(`SocialSecurity`)
  }

  let documentContent = ''
  if (props.content) {
    documentContent = props.content
  }

  return (
    <div className='break-before break-after social-security-wrapper u-flexWrap u-flex u-flexJustifyCenter'>
      <div className='social-security-info u-sizeFull u-flexWrap social-security-content u-flex  u-bgColorWhite u-padding10gu'>
        <div className='u-pt-sizeFull u-size1of2'>
          {documentContent && (
            <>
              <div
                dangerouslySetInnerHTML={{
                  __html: sanitizeHTML(documentContent),
                }}></div>
            </>
          )}
        </div>

        <div className='u-pt-flex u-size1of3 u-flexWrap u-pt-block u-hidden u-marginLeft10gu'>
          <div className='u-sizeFull'>
            <p className='u-textPrimary u-textSizeMsrp'>Social Security Full Retirement Age:</p>
          </div>
          <div className='u-sizeFull'>
            <p className='u-textPrimary u-textSizeMsrp u-textBold'>{returnFRA(state.FRAValue)}</p>
          </div>
          <div className='u-sizeFull'>
            <p className='u-textPrimary u-textSizeMsrp'>Social Security Claiming Age:</p>
          </div>
          <div className='u-sizeFull'>
            <p className='u-textPrimary u-textSizeMsrp u-textBold'>
              {returnRetirementAge(state.ageOfCollectionValue)}
            </p>
          </div>
        </div>

        <div className='u-pt-hidden u-size1of3 u-marginLeft10gu'>
          <label
            className='Form-label u-textSizeMsrp1 u-textColorBrand  u-textPrimary'
            htmlFor='full-retirement-age'>
            Social Security Full Retirement Age (FRA)
          </label>

          <div className='Dropdown u-marginBottom4gu'>
            <select
              ref={FRARef}
              onChange={handleChangeFRA}
              className={`Dropdown-menu ${FRAError ? 'Input--error' : ''}`}
              id='full-retirement-age'>
              {fraOptions.map((option, index) => (
                <option key={index} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
            {FRAError && <p className='Form-help u-textColorAlert'>Please select an option.</p>}
          </div>

          <label
            className='Form-label u-textSizeMsrp1 u-textColorBrand u-marginBottom3gu u-textPrimary'
            htmlFor='age-of-collection'>
            Social Security Claiming Age
          </label>
          <div className='Dropdown u-marginBottom6gu'>
            <select
              ref={ageOfCollectionRef}
              onChange={handleChangeAOC}
              className={`Dropdown-menu ${ageOfCollectionError ? 'Input--error' : ''}`}
              id='age-of-collection'>
              {ageOptions.map((option, index) => (
                <option key={index} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
            {ageOfCollectionError && (
              <p className='Form-help u-textColorAlert'>Please select an option.</p>
            )}
          </div>
          <label
            className='Form-label u-textSizeMsrp1 u-textColorBrand u-marginBottom3gu u-textPrimary'
            htmlFor='monthly-social-security-benefit-estimate'>
            Monthly Social Security Benefit Estimate (FRA)
          </label>
          <CurrencyInput
            name='monthly-social-security-benefit-estimate'
            id='monthly-social-security-benefit-estimate'
            value={state.monthlySocialSecurityBenefitEstimate}
            valueChanged={value => handleStateChange('monthlySocialSecurityBenefitEstimate', value)}
          />
          <div className='ButtonRow u-flex u-flexWrap'>
            <button
              className='Button Button--primary u-paddingHoriz7gu u-paddingVert2gu'
              data-analytics='RIG-social-security-see-results-button'
              onClick={() => {
                handleSeeResults()
              }}>
              See Results
            </button>

            {state.resultsVisible && (
              <button
                className='u-flex u-flexAlignItemsCenter Button Button--secondary u-paddingHoriz7gu u-paddingVert2gu'
                onClick={() => {
                  handleReset()
                }}>
                <span className='u-paddingRight2gu'>Reset</span>
                <svg
                  width='25'
                  height='22'
                  viewBox='0 0 25 22'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'>
                  <path
                    d='M3.31513 13.7592C3.46534 13.9409 3.70862 13.9409 3.85882 13.7592L7.09517 9.8416C7.24538 9.65984 7.17462 9.51253 6.93738 9.51253H5.21898C4.98173 9.51253 4.82048 9.32453 4.87144 9.09532C5.75504 5.11415 9.34608 2.12491 13.6315 2.12491C18.578 2.12491 22.6022 6.10626 22.6022 11C22.6022 15.8938 18.578 19.8751 13.6315 19.8751C13.0385 19.8751 12.5576 20.3508 12.5576 20.9376C12.5576 21.5243 13.0385 22 13.6315 22C19.7624 22 24.75 17.0655 24.75 11C24.75 4.93453 19.7623 0 13.6315 0C8.15851 0 3.59921 3.93358 2.68365 9.09282C2.64256 9.32402 2.42535 9.51258 2.1881 9.51258H0.236619C-0.000671866 9.51258 -0.0712367 9.65989 0.0787838 9.84165L3.31513 13.7592Z'
                    fill='#1274bb'
                  />
                </svg>
              </button>
            )}
          </div>
        </div>
      </div>

      <SocialSecurityTable
        resultsVisible={state.resultsVisible}
        tableData={tableDefaults}
        highlightedColumn={ageOfCollectionValueToColumn(state.ageOfCollectionValue)}
        highlightedRow={FRAValueToRow(state.FRAValue)}
        estimate={state.monthlySocialSecurityBenefitEstimate}
      />

      <div className='social-security-table-labels avoid-break-before social-security-content u-sizeConstrained u-sizeFull u-flex u-paddingBottom10gu u-marginHoriz10gu u-bgColorWhite u-flexJustifyBetween'>
        <div className='social-security-table-label u-textPrimary u-paddingLeft7gu u-textColorBrand u-textBold u-textSizeMsrp1'>
          Reduced Benefits
        </div>
        <div className='increased-benefits  social-security-table-label u-textPrimary u-paddingRight7gu u-textColorBrand u-textBold u-textSizeMsrp1'>
          Increased Benefits
        </div>
      </div>
    </div>
  )
}

export default SocialSecurity
